import React, { useState, useContext } from "react";
import { ContextProvider } from "../../App";
// import ReactDom to create react portals
import ReactDOM from "react-dom";
import "./auth.css";
import TextField from "./TextField.jsx";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import axios from "axios";
import EmailVerificationModal from "./EmailVerificationModal.jsx";
import ReferralsIcon from "../../images/referralsIcon.svg";
import ClipLoader from "react-spinners/ClipLoader";
import toast, { Toaster } from "react-hot-toast";

function SignUp({ signUp, handleSignUpClose, handleClickedSignIn }) {
  // const {authDispatch } = useContext(ContextProvider)

  const [verifyEmail, setVerifyEmail] = useState(false);
  const [signUpLoading, setSignUpLoading] = useState(false);

  const validate = Yup.object({
    name: Yup.string()
      .min(3, "Must be 3 characters or more")
      .required("Name is Required"),
    email: Yup.string()
      .email("Invalid email address")
      .required("Email is Required"),
    mobile: Yup.number()
      .required("Phone Number is Required")
      .positive("Mobile Number cannot be Negative")
      .integer("Mobile Number should be Number"),
    zipCode: Yup.string().required("Zip Code is Required"),
    password: Yup.string()
      .min(6, "Must be 6 characters or more")
      .required("Password is Required"),
  });

  const handleSignUpUser = async (values, onSubmitProps) => {
    setSignUpLoading(true);
    try {
      const response = await axios.post("/api/v1/signup", values);
      if (response.data.success === true) {
        setSignUpLoading(false);
        setVerifyEmail(response.data.success);
        handleSignUpClose();
        toast.success(response.data.message, {
          duration: 4000,
          position: "top-left",
        });
        setTimeout(() => {
          setVerifyEmail(false);
        }, 5000);
        onSubmitProps.resetForm()
      } else {
        setSignUpLoading(false);
        toast.error(response.data.message, {
          duration: 3000,
          position: "top-left",
        });
      }
    } catch (error) {
      if (error.response) {
        setSignUpLoading(false);
        toast.error(error.response.data.message, {
          duration: 4000,
          position: "top-left",
        });
      }
    }
  };

  return ReactDOM.createPortal(
    // react portals for implement child outside the root id
    <>
      <Toaster />
      <EmailVerificationModal verifyEmail={verifyEmail} />

      <Formik
        initialValues={{
          name: "",
          email: "",
          mobile: "",
          zipCode: "",
          password: "",
        }}
        validationSchema={validate}
        onSubmit={(values, onSubmitProps) => {
          handleSignUpUser(values, onSubmitProps);
        }}
      >
        {(formik) => (
          <>
            <div className={signUp ? "backdrop" : "backdropHide"}></div>
            <div
              className={signUp ? "signup_containerOpen" : "signup_container"}
            >
              <Form>
                <div className="signup_header">
                  <p>Sign Up</p>
                  <p>
                    <i
                      className="far fa-times-circle"
                      style={{ cursor: "pointer" }}
                      onClick={handleSignUpClose}
                    ></i>
                  </p>
                </div>

                <div className="signup_inputs">
                  <TextField
                    type="text"
                    placeholder="Name"
                    name="name"
                    autoComplete="off"
                    className="form_input"
                  />
                  <TextField
                    type="email"
                    placeholder="Email"
                    name="email"
                    autoComplete="off"
                    className="form_input"
                  />
                  <TextField
                    type="tel"
                    placeholder="Mobile No"
                    name="mobile"
                    autoComplete="off"
                    className="form_input"
                  />
                  <TextField
                    type="text"
                    placeholder="Zip Code"
                    name="zipCode"
                    autoComplete="off"
                    className="form_input"
                  />
                  <TextField
                    type="password"
                    placeholder="Password"
                    name="password"
                    autoComplete="off"
                    className="form_input"
                  />
                </div>
                <div className="signup_referral_code">
                  <div className="referral_code">
                    <img src={ReferralsIcon} alt="referral_icon" />
                    <div
                      style={{ marginLeft: ".8rem" }}
                      className="referralsText"
                    >
                      <span>Referral Code</span>
                      <p>Add a personalized gift note to your order</p>
                    </div>
                  </div>
                  <p>
                    <u>View Option</u>
                  </p>
                </div>
                <div className="signup_submit_btn">
                  <button
                    type="submit"
                    className="signUpBtn"
                    disabled={signUpLoading ? true : false}
                  >
                    {signUpLoading ? (
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          flexDirection: "row",
                        }}
                      >
                        <ClipLoader
                          color="#fff"
                          loading={signUpLoading}
                          speedMultiplier="1.8"
                          size={20}
                          style={{ marginRight: ".4rem" }}
                        />{" "}
                        <p style={{ marginLeft: ".4rem", color: "#fff" }}>
                          Loading...
                        </p>
                      </div>
                    ) : (
                      "SIGN UP"
                    )}
                  </button>
                </div>
                <div className="q_text">
                  <span>
                    <b>Already Have Account ?</b>{" "}
                    <b
                      style={{ color: "#FBA922", cursor: "pointer" }}
                      onClick={handleClickedSignIn}
                    >
                      Sign In
                    </b>
                  </span>
                </div>
              </Form>
            </div>
          </>
        )}
      </Formik>
    </>,
    document.getElementById("auth-portal-root") // another root id
  );
}

export default SignUp;
